module.exports = __webpack_public_path__ + "img/4-2.1995f0f4.svg";